import { ComponentRef, Directive, Input, OnChanges, OnInit, Type, ViewContainerRef } from '@angular/core';
import { NkDatatableDetails } from '../datatable.utils';

@Directive({
  selector: '[nkDatatableRowDetails]',
  standalone: false,
})
export class DatatableRowDetailsDirective<T> implements OnInit, OnChanges {
  @Input() public highlightText: string | undefined;
  @Input() public nkDatatableRowDetailsComponent!: Type<NkDatatableDetails<T>>;
  @Input() public set nkDatatableRowDetails(row: T) {
    this._nkDatatableRowDetails = row;
    this._updateValue(this._nkDatatableRowDetails);
  }
  public get nkDatatableRowDetails(): T {
    return this._nkDatatableRowDetails;
  }
  private _nkDatatableRowDetails!: T;
  private _componentRef!: ComponentRef<NkDatatableDetails<T>>;

  constructor(private _container: ViewContainerRef) {}

  private _updateValue(row: T): void {
    if (this._componentRef) {
      this._componentRef.instance.row = row;
      this._componentRef.instance.highlightText = this.highlightText;
    }
  }

  public ngOnInit(): void {
    if (this.nkDatatableRowDetailsComponent) {
      this._componentRef = this._container.createComponent(this.nkDatatableRowDetailsComponent);
      this._updateValue(this.nkDatatableRowDetails);
    }
  }

  public ngOnChanges(): void {
    if (typeof this.highlightText === 'string' && this._componentRef?.instance) {
      this._componentRef.instance.highlightText = this.highlightText;
    }
  }
}
